<template>
  <div class="BuyLedger">
    <ATable
      ref="table"
      v-loading="loading"
      buttons-width="500px"
      max-height="650"
      :data="filteredItems"
      :disabled="disabled"
      :summaryTitleColumnIndex="6"
      :summaryFields="summaryFields"
      show-summary
      hide-pagination
      hide-button-insert
      border
      @selection-change="handleSelectionChange"
    >
      <div slot="search">
        <div class="inline">
          <div class="inline bold">매입일</div>
          <ADatePicker
            v-model="searchDate"
            class="inline ml-default"
            placeholder="날짜 선택"
            :disabled="disabled || inboundBusy"
            @change="handleChangeDate"
          />
        </div>
        <div class="inline ml-default">
          <el-select
            v-model="order_code"
            placeholder="발주번호"
            :disabled="disabled || inboundBusy"
          >
            <el-option
              v-for="item in orderCodes"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </div>
      </div>
      <el-table-column
        type="selection"
        label="선택"
        align="center"
        :width="$width.selection"
      />
      <el-table-column
        type="index"
        label="No"
        :index="handleIndex"
        :width="$width.index"
      />
      <el-table-column
        prop="inbound_date"
        label="입고일"
        :width="$width.date"
        show-overflow-tooltip
      />
      <el-table-column prop="code" label="입고번호" width="100" />
      <el-table-column
        prop="order_inbound_state"
        width="100"
        :formatter="formatInboundState"
      >
        <template slot="header">
          <el-tooltip :content="inboundStateHelp" placement="top">
            <span>입고 상태 <i class="el-icon-question"/></span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="product_name" label="품목" show-overflow-tooltip />
      <el-table-column
        prop="size"
        :label="$t('lang.size')"
        width="100"
        show-overflow-tooltip
      />
      <el-table-column
        prop="amount"
        label="수량"
        class-name="cell-number"
        :width="$width.amount"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.id === editingId">
            <ANumberInput
              v-model="scope.row.amount"
              allowDecimal
              @change="handleChangeCost(scope.row)"
            />
          </div>
          <div v-else>
            {{ util.addComma(scope.row.amount) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="unit_name"
        label="단위"
        :width="$width.unit_name"
      />
      <el-table-column
        prop="cost"
        label="단가"
        class-name="cell-number"
        :width="$width.price"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.id === editingId">
            <ANumberInput
              v-model="scope.row.cost"
              allowDecimal
              @change="handleChangeCost(scope.row)"
            />
          </div>
          <div v-else>
            {{ util.addComma(scope.row.cost) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="supply_price"
        label="공급가액"
        class-name="cell-number"
        :width="$width.price"
        :formatter="util.numberFormat"
      />
      <el-table-column
        prop="tax"
        label="세액"
        class-name="cell-number"
        :width="$width.price"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.id === editingId">
            <ANumberInput
              v-model="scope.row.tax"
              @change="handleChangeTax(scope.row)"
            />
          </div>
          <div v-else>
            {{ util.addComma(scope.row.tax) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="price"
        label="금액"
        class-name="cell-number"
        :width="$width.price"
        :formatter="util.numberFormat"
      />
      <el-table-column
        prop="desc"
        label="비고"
        width="200"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <div v-if="scope.row.id === editingId">
            <el-input size="tiny" v-model="scope.row.desc" />
          </div>
          <div v-else>
            {{ scope.row.desc }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="created_user_name"
        :label="$t('lang.created_user_name')"
        :width="$width.username"
      />
      <el-table-column
        prop="modified_user_name"
        :label="$t('lang.modified_user_name')"
        :width="$width.username"
      />
      <el-table-column
        prop="created_at"
        :label="$t('lang.created_at')"
        :width="$width.date"
        :formatter="util.dateFormat"
      />
      <el-table-column
        prop="modified_at"
        :label="$t('lang.modified_at')"
        :width="$width.date"
        :formatter="util.dateFormat"
      />
      <el-table-column
        label="명령"
        width="115"
        fixed="right"
        v-if="has_grant_write"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.id === editingId">
            <el-button
              type="primary"
              size="mini"
              @click="handleClickUpdate(scope.row)"
              >저장</el-button
            >
            <el-button size="mini" @click="calcelEditing">취소</el-button>
          </div>
          <div v-else>
            <el-button size="mini" @click="handleClickModify(scope.row)"
              >수정</el-button
            >
          </div>
        </template>
      </el-table-column>
      <div slot="buttons">
        <el-button
          :disabled="disabled || inboundBusy || !has_grant_write"
          @click="handleClickCreate"
          >수기 매입</el-button
        >
        <el-button
          type="danger"
          :disabled="cancelDisabled"
          @click="handleClickDeleteItems"
          >입고 단위 입고 취소</el-button
        >
        <el-button
          type="danger"
          :disabled="cancelDisabled"
          @click="handleClickDelete"
          >발주 단위 입고 취소</el-button
        >
        <div v-if="editingId > 0" class="cancel-hint">
          편집을 저장하거나 취소한 뒤 처리해 주세요.
        </div>
      </div>
    </ATable>
    <el-dialog
      custom-class="form-dialog"
      top="0"
      :width="showPyungProcessingCost ? '1500px' : '1300px'"
      title="수기 매입"
      :visible.sync="dialog_visible"
      :close-on-click-modal="false"
      :before-close="beforeClose"
      destroyOnClose
      @opened="handleOpened"
    >
      <InboundForm
        ref="form"
        v-if="dialog_visible"
        :customer="customer"
        @completed="handleCompleted"
      />
    </el-dialog>
  </div>
</template>
<script>
import { form_container } from "@/common/mixins/form_container";
import { company_info } from "@/common/mixins/company_info";
import { inbound_process } from "@/common/mixins/inbound_process";
import InboundForm from "./InboundForm";

export default {
  name: "BuyLedger",
  mixins: [form_container, company_info, inbound_process],
  components: { InboundForm },
  data() {
    return {
      company: {
        show_pyung_processing_cost: false
      },
      title: this.$t("title.buy_ledger"),
      items: [],
      order_code: null,
      searchDate: this.util.getDate(),
      search_period: { value: "1m" },
      period: {},
      loading: false,
      selection: [],
      editingItem: null,
      editingId: 0,
      dialog_visible: false,
      summaryFields: ["cost", "supply_price", "tax", "price"],
      change_code_flag: false,
      // 취소 흐름(확인창을 열 때부터 처리와 결과 알림이 끝날 때까지)이 진행 중인지 여부
      cancelFlow: false,
      // 취소 흐름 중에 요청된 조회를 흐름이 끝난 뒤에 한 번 실행하기 위한 표시
      pendingLoad: false,
    };
  },
  props: {
    customer: {
      type: Object,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    has_grant_write: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    customer: function() {
      this.order_code = null;
      this.change_code_flag = true;
      this.loadData();
    },
    table_config() {
      this.loadConfig()
    },
  },
  computed: {
    showPyungProcessingCost() {
      return this.company.show_pyung_processing_cost;
    },
    selectionIds() {
      if (this.selection.length < 1) {
        return [];
      }
      return this.selection.map((s) => s.id);
    },
    orderCodes() {
      if (this.items.length < 1) {
        return [];
      }
      let items = [];
      this.items.forEach((item) => {
        if (!item.order_code) {
          return true;
        }
        let index = items.findIndex((e) => e.value === item.order_code);
        if (index < 0) {
          items.push({ value: item.order_code, label: item.order_code });
        }
        if (this.change_code_flag) {
          this.order_code = items[0].value;
          this.change_code_flag = false;
        }
      });
      items.splice(items.length, 0, { value: null, label: "수기매입" });
      return items;
    },
    filteredItems() {
      return this.items.filter((item) => item.order_code === this.order_code);
    },
    /** 처리 중, 확인 중, 행 편집 중에는 취소할 수 없다. */
    cancelDisabled() {
      return (
        this.inboundBusy ||
        this.editingId > 0 ||
        this.selection.length < 1 ||
        !this.has_grant_write
      );
    },
  },
  mounted() {
    this.loadConfig()
  },
  methods: {
    loadData() {
      // 취소 흐름 중에는 조회하지 않고 표시만 남긴다(부모 화면의 호출 포함).
      // 미뤄 둔 조회는 cancelInbound()가 흐름이 끝난 뒤에 한 번 실행한다.
      if (this.cancelFlow || this.inboundBusy) {
        this.pendingLoad = true;
        return;
      }
      this.pendingLoad = false;
      if (!this.customer) {
        return;
      }
      if (!this.period) {
        return;
      }
      this.loading = true;
      let period = {
        startDate: this.searchDate,
        endDate: this.searchDate,
      };
      let param = {};
      if (this.customer) {
        param.customer_id = this.customer.id;
      }
      this.api.listInboundDetail(period, param).then((res) => {
        this.loading = false;
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.title, res);
          return;
        }
        this.items = res.data;
      });
    },
    calcelEditing() {
      if (this.editingId < 1) {
        return;
      }
      let index = this.items.findIndex((i) => i.id === this.editingItem.id);
      if (index > -1) {
        this.items.splice(index, 1, this.editingItem);
      }
      this.editingItem = null;
      this.editingId = 0;
    },
    async cancelInbound(unit) {
      if (!this.has_grant_write || this.cancelFlow) {
        return;
      }
      if (this.editingId > 0) {
        this.util.notify_warning(
          this,
          this.title,
          "편집을 저장하거나 취소한 뒤 처리해 주세요."
        );
        return;
      }
      // 확인하는 사이 거래처, 매입일, 발주번호가 바뀌거나 편집을 시작했으면 요청하지 않는다.
      const customer = this.customer;
      const searchDate = this.searchDate;
      const order_code = this.order_code;
      this.cancelFlow = true;
      try {
        await this.cancelInboundWithConfirm(this.selection, unit, {
          isValid: () =>
            this.customer === customer &&
            this.searchDate === searchDate &&
            this.order_code === order_code &&
            this.editingId < 1,
          // 요청을 보냈으면 성공/실패와 관계없이 선택을 초기화하고 조회를 예약한다.
          reload: () => {
            this.selection = [];
            this.pendingLoad = true;
          },
        });
      } finally {
        // 조회는 여기서만 시작한다. 취소 뒤의 갱신과, 흐름 중에 미뤄 둔 조회
        // (확인을 거절했거나 조건이 바뀌어 보내지 않은 경우 포함)를 현재 조건으로 한 번 실행한다.
        this.cancelFlow = false;
        if (this.pendingLoad) {
          this.loadData();
        }
      }
    },
    handleChangeDate(period) {
      if (this.inboundBusy) {
        return;
      }
      this.period = period;
      this.order_code = null;
      this.change_code_flag = true;
      this.items = [];
      this.loadData();
    },
    handleIndex(index) {
      return this.$refs.table.indexResolver(index);
    },
    handleSelectionChange(selection) {
      this.selection = selection;
    },
    handleChangeCost(item) {
      item.supply_price = item.cost * item.amount;
      item.tax = Math.ceil(item.supply_price * 0.1);
      item.price = item.supply_price + item.tax;
    },
    handleChangeTax(item) {
      item.price = item.supply_price + item.tax;
    },
    handleClickModify(item) {
      if (this.inboundBusy) {
        return;
      }
      if (this.editingId === item.id) {
        return;
      }
      if (this.editingId > -1) {
        this.calcelEditing();
      }
      this.editingItem = Object.assign({}, item);
      this.editingId = item.id;
    },
    handleClickUpdate(item) {
      if (this.inboundBusy) {
        return;
      }
      this.loading = true;
      this.api.updateInbound(item).then((res) => {
        this.loading = false;
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.title, res);
          return;
        }
        this.util.notify_success(
          this,
          this.title,
          this.$t("message.success_update")
        );
        this.loadData();
        this.calcelEditing();
      });
    },
    /** 발주 단위 입고 취소: 선택한 입고가 속한 발주의 모든 입고를 취소한다. */
    handleClickDelete() {
      return this.cancelInbound("order");
    },
    /** 입고 단위 입고 취소: 선택한 입고만 취소한다. */
    handleClickDeleteItems() {
      return this.cancelInbound("item");
    },
    handleClickCreate() {
      if (this.inboundBusy) {
        return;
      }
      this.dialog_visible = true;
    },
    handleCompleted(result) {
      this.dialog_visible = false;
      if (!result) {
        return;
      }
      this.loadData();
    },
  },
};
</script>
<style lang="scss" scoped>
.cancel-hint {
  margin-top: 4px;
  color: #f56c6c;
  font-size: 12px;
}
</style>
